import React from 'react';
import { View } from '../types';
import { HomeIcon } from './icons/HomeIcon';
import { ServicesIcon } from './icons/ServicesIcon';
import { CalendarIcon } from './icons/CalendarIcon';
import { ListIcon } from './icons/ListIcon';
import { HolidayIcon } from './icons/HolidayIcon';
import { BookingIcon } from './icons/BookingIcon';
import { DraftIcon } from './icons/DraftIcon';
import { ReportIcon } from './icons/ReportIcon';

interface SidebarProps {
  currentView: View;
  setCurrentView: (view: View) => void;
  draftCount?: number;
}

const Sidebar: React.FC<SidebarProps> = ({ currentView, setCurrentView, draftCount = 0 }) => {
  const navItems = [
    { id: 'dashboard', label: 'דף הבית', icon: HomeIcon },
    { id: 'appointmentsSummary', label: 'סיכום תורים', icon: ListIcon },
    { id: 'booking', label: 'קביעת תור', icon: BookingIcon },
    { id: 'drafts', label: 'תורים לא הושלמו', icon: DraftIcon },
    { id: 'reports', label: 'דוחות וסטטיסטיקות', icon: ReportIcon },
    { id: 'reminderHistory', label: 'היסטוריית תזכורות', icon: ReportIcon },
    { id: 'services', label: 'שירותים', icon: ServicesIcon },
    { id: 'technicians', label: 'ניהול טכנאים', icon: ServicesIcon },
    { id: 'schedule', label: 'ניהול שעות עבודה', icon: CalendarIcon },
    // { id: 'holidays', label: 'חגים וסגירות', icon: HolidayIcon },
  ];

  return (
    <div className="w-64 bg-gradient-to-b from-slate-900 via-slate-900 to-slate-800 text-slate-300 flex flex-col h-screen fixed right-0 top-0 shadow-2xl">
      <div className="p-6 text-center border-b border-slate-700/50 bg-slate-800/30 backdrop-blur-sm">
        <div className="flex items-center justify-center mb-3">
          <img 
            src="/logo.png" 
            alt="לוגו מרפאה" 
            className="h-16 w-16 object-contain drop-shadow-lg"
          />
        </div>
        <h1 className="text-2xl font-bold text-white bg-gradient-to-r from-teal-400 to-cyan-400 bg-clip-text text-transparent">
          מרכז מונא הרפואי
        </h1>
        <p className="text-sm text-slate-400 mt-1">לוח ניהול</p>
      </div>
      <nav className="flex-1 p-4 overflow-y-auto">
        <ul className="space-y-1">
          {navItems.map((item) => {
            const Icon = item.icon;
            const isActive = currentView === item.id;
            const showBadge = item.id === 'drafts' && draftCount > 0;
            return (
              <li key={item.id}>
                <button
                  onClick={() => setCurrentView(item.id as View)}
                  className={`group relative flex items-center justify-between w-full p-3 rounded-xl transition-all duration-300 ${
                    isActive
                      ? 'bg-gradient-to-r from-teal-600 to-cyan-600 text-white shadow-lg shadow-teal-500/50 scale-105'
                      : 'hover:bg-slate-800/80 hover:text-white hover:scale-102 hover:shadow-md'
                  }`}
                >
                  <div className="flex items-center gap-3">
                    <div className={`transition-transform duration-300 ${isActive ? '' : 'group-hover:scale-110'}`}>
                      <Icon className="w-5 h-5" />
                    </div>
                    <span className="font-medium text-sm">{item.label}</span>
                  </div>
                  {showBadge && (
                    <span className="bg-gradient-to-r from-red-500 to-pink-500 text-white text-xs font-bold px-2.5 py-1 rounded-full min-w-[24px] text-center shadow-lg animate-pulse">
                      {draftCount}
                    </span>
                  )}
                  {isActive && (
                    <div className="absolute left-0 top-1/2 -translate-y-1/2 w-1 h-8 bg-white rounded-r-full"></div>
                  )}
                </button>
              </li>
            );
          })}
        </ul>
      </nav>
      <div className="p-4 border-t border-slate-700/50 text-center text-xs text-slate-500 bg-slate-800/30">
        <p className="font-medium">© 2025 מערכת תורים</p>
        <p className="text-slate-600 mt-1">v1.2</p>
      </div>
    </div>
  );
};

export default Sidebar;